import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-general-6',
  templateUrl: './6.component.html',
  styleUrls: ['./6.component.scss'],
})
export class CuiGeneral6Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
